import { API_BASE_URL, apiRequest } from './apiClient';

export type ApiMeResponse = {
  displayName: string | null;
  email: string | null;
  externalId?: string | null;
  appAuthToken?: string | null;
  userPrincipalName?: string | null;
  tenantId?: string | null;
  user?: {
    id?: string | null;
    name?: string | null;
    email?: string | null;
    externalId?: string | null;
  } | null;
  raw?: unknown;
};

export type OwnedBoardSummary = {
  id: string;
  title: string;
  created: string | null;
};

type OwnedBoardApiResponse = {
  id?: string;
  _id?: string;
  title?: string;
  created?: string;
};

const API_ME_PATH = '/teams/me';

const resolveApiUrl = (path: string) => {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  if (!API_BASE_URL) return path;
  return `${API_BASE_URL}${path}`;
};

export const teamsSetupApi = {
  getMe(authToken: string) {
    return apiRequest<ApiMeResponse>(
      API_ME_PATH,
      { method: 'GET' },
      { Authorization: `Bearer ${authToken}` }
    );
  },
  getMeUrl() {
    return resolveApiUrl(API_ME_PATH);
  },
  getOauthStartUrl() {
    return resolveApiUrl('/teams/oauth/start');
  },
  async getOwnedBoards(authToken: string) {
    const payload = await apiRequest<OwnedBoardApiResponse[]>(
      '/topics',
      { method: 'GET' },
      { Authorization: `Bearer ${authToken}` }
    );

    return payload
      .map((board) => ({
        id: board.id ?? board._id ?? '',
        title: board.title ?? 'Untitled board',
        created: board.created ?? null,
      }))
      .filter((board) => board.id.length > 0);
  },
};
